<style lang="scss" scoped>
.jy-index {
    .topbanner {
        width: 375px;
        height: 160px;
        background: url("/static/images/strategy/bg_banner.png") no-repeat;
        background-size:375px 160px;
        .title {
            display: inline-block;
            margin: 35px 0 8px 25px;
            font-size: 40px;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            line-height: 40px;
            letter-spacing: 1px;
        }
        .subtitle {
            display: block;
            margin-left: 25px;
            font-size: 20px;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            line-height: 20px;
        }
    }
    .itemBox {
        display: flex;
        flex-wrap: wrap;

        .box {
            width: 50%;
            box-sizing: border-box;
            display: flex;
            padding-left: 36px;
            margin: 21px 0;
            align-items: center;
            .img {
                width: 28px;
                height: 28px;
            }
            .name {
                margin-left: 20px;
                height: 20px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(66, 66, 66, 1);
                line-height: 20px;
            }
        }
    }
}
</style>

<template>
  <div class="jy-index">
    <nav-bar navbartitle="拓客攻略" @backClick="backClick"></nav-bar>
    <!-- 顶部图 -->
    <div class="topbanner">
      <span class="title">拓客攻略</span>
      <span class="subtitle">带你玩转剑琅联盟</span>
    </div>

    <!-- 下面选项 -->
    <div class="itemBox">
      <template v-for="(item,index) in list">
        <div class="box" v-if="item.userType.indexOf(userType)>-1" :key="index" @click="handleClick(item.type)">
          <img class="img" :src="'/static/images/strategy/'+item.icon+'.png'" alt>
          <span class="name">{{item.name}}</span>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import NavBar from "@/components/navBar";
export default {
  data() {
    return {
      deviceType:'',
      userType: 1, // 1. 店主，2.店员
      list: [
        {name: "拓客", type: "extension", icon: "icon_extension", userType: [1, 2]},
        {name: "店铺维护", type: "shop", icon: "icon_shop", userType: [1]},
        {name: "创建优惠活动", type: "create", icon: "icon_create", userType: [1]},
        {name: "扫码验券", type: "scancode", icon: "icon_scancode", userType: [1, 2]},
        {name: "积分结账", type: "bill", icon: "icon_bill", userType: [1, 2]},
        {name: "获客费用支付", type: "pay", icon: "icon_pay", userType: [1]},
        {name: "推荐费用提现", type: "withdraw", icon: "icon_withdraw", userType: [1, 2]},
        {name: "个人秀维护", type: "set", icon: "icon_set", userType: [1, 2]},
        {name: "员工管理", type: "staff", icon: "icon_staff", userType: [1]},
        // {name: "积分兑换设置", type: "icon", icon: "icon", userType: [1]},
      ]
    };
  },
  created() {
    console.log("ua", JSON.parse(navigator.userAgent));
    this.deviceType = JSON.parse(navigator.userAgent).device;
    localStorage.setItem("device",this.deviceType);
    this.userType = Number(this.$route.params.userType) || 1;
  },
  methods: {
    handleClick(type) {
      this.$router.push({name: "strategyDetail", params: {type}});
    },
    backClick() {
      console.log("点击返回");
      if (this.deviceType === "iphoneX" || this.deviceType === "iphoneOther") {
        window.webkit.messageHandlers.AppModel.postMessage({
          body: "close",
          isAlert: "false"
        });
      } else if (this.deviceType === "android") {
        window.nativeMethod.close();
      }
    }
  },
  components: {
    NavBar
  }
};
</script>



// WEBPACK FOOTER //
// src/views/strategy/index.vue